import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { useJobDetails } from "../../../providers/jobDetailsProvider";
import { NumericFormat } from "react-number-format";
import moment from "moment";
import { orderAcknowledgmentApi } from "../../../services/orderAcknowledgmentServices";
import { utils } from "../../../utils/utils";
import InformationModal from "../../InformationModal";

const PAGE_NUMBER = 0;
const PAGE_SIZE = 99999;

const JobDetailsSummary = () => {
  const [jobDetails] = useJobDetails();
  const [totalAmount, setTotalAmount] = useState(0);
  const { job } = jobDetails;
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );

  useEffect(() => {
    const fetchOrderAcknowledgments = async () => {
      if (job) {
        try {
          const result = await orderAcknowledgmentApi.getAll({
            jobId: job.id,
            page: PAGE_NUMBER,
            pageSize: PAGE_SIZE,
          });
          const records = result.data || [];
          const total = records.reduce(
            (acc, curr) => acc + (curr.amount || 0),
            0
          );
          setTotalAmount(total);
        } catch (err) {
          setInformationModal({
            isOpen: true,
            title: "Error",
            body: "There was an error fetching the order acknowledgments.",
            onClose: () =>
              setInformationModal({ ...utils.initInformationModal }),
          });
        }
      }
    };

    fetchOrderAcknowledgments();
  }, [job]);

  if (!job) {
    return null;
  }

  return (
    <Card className="m-0 h-100 p-3">
      <CardHeader className="bg-white border-0 p-0 pb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="rounded-circle d-flex align-items-center justify-content-center p-2 bg-soft-blue">
              <FontAwesomeIcon icon={faSearch} size="lg" />
            </div>
            <h4 className="mb-0 ml-3 font-weight-bold">Job Details</h4>
          </div>
          <Link to={`/jobs/${job.id}/details`} className="text-dark">
            <FontAwesomeIcon icon={faExternalLinkAlt} size="lg" />
          </Link>
        </div>
      </CardHeader>
      <CardBody className="p-0 pt-3">
        <Row className="mt-4">
          <Col>
            <p className="text-muted mb-1">Contract Date</p>
            <h6 className="m-0">
              {job.contractDate
                ? moment(job.contractDate).format("M/DD/YY")
                : "-"}
            </h6>
          </Col>
          <Col>
            <p className="text-muted mb-1">Contract Amount</p>
            <h6 className="m-0">
              <NumericFormat
                value={totalAmount}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </h6>
          </Col>
        </Row>
      </CardBody>
      {informationModal.isOpen && (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={informationModal.onClose}
        />
      )}
    </Card>
  );
};

export default JobDetailsSummary;
